import { makeApiCall, ApiResponse } from "./index";

const BASE_URL = process.env.REACT_APP_API_VEHICLE_URL;

export function GetAllVehicleMakes(
  clientId?: string,
  queryParams?: any
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}makes`, "GET", queryParams);
}

export function GetAllVehicleMakeSearch(
  clientId?: string,
  queryParams?: any
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}makes/search`, "GET", queryParams);
}

export function GetVehicleMakeById(makeId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}makes/${makeId}`, "GET");
}

export function DeleteVehicleMake(makeId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}makes/${makeId}`, "DELETE");
}

export function AddVehicleMake(body: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}makes`, "POST", body);
}

export function EditVehicleMake(Id: Number, body: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}makes/${Id}`, "PUT", body);
}

export function RestoreVehicleMake(
  Id: Number,
  body: any
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}makes/${Id}`, "PATCH");
}
